import { Box } from '@chakra-ui/react';
import Loading from '@components/Loading';
import PaginationRouterContainer from '@components/PaginationRouterContainer';

import { useCustomersContext } from '../context';
import CustomerCard from './CustomerCard';

const List = () => {
  const {
    getCustomers,
    customers,
    totalPages,
    loading,
  } = useCustomersContext();

  if (loading && customers.length === 0) return <Loading />;

  if (!loading && customers.length === 0) {
    return (
      <Box textAlign="center" mt={20} color="gray.500">
        Nenhum cliente encontrado.
      </Box>
    );
  }

  return (
    <Box opacity={loading ? 0.5 : 1} transition="opacity 0.15s ease">
      <PaginationRouterContainer
        total={totalPages}
      >
        {customers.map((customer) => (
          <CustomerCard
            key={customer.id}
            customer={customer}
            refetch={() => getCustomers({})}
          />
        ))}
      </PaginationRouterContainer>
    </Box>
  );
};

export default List;
